import { useCallback, useMemo } from "react";

import { useFilter } from "@/context/FilterContext";

import type { CategoryFiltersProps } from "./CategoryFilters.inputs.builder";

type UseHandleFiltersProps = {
  subcategoriesWithProductCount: CategoryFiltersProps["subcategoriesWithProductCount"];
};

const useHandleFilters = ({ subcategoriesWithProductCount }: UseHandleFiltersProps) => {
  const { filterState, toggleCategory, discontinuedProductName } = useFilter();

  const updatedSubcategories = useMemo(() => {
    return (
      subcategoriesWithProductCount?.map((subcategory) => ({
        uid: subcategory.uid ?? "",
        name: subcategory.name ?? "",
        checked: filterState.selectedCategoryUids.includes(subcategory.uid ?? ""),
        image: subcategory.image ?? "",
        productCount: subcategory.productCount,
        newBadge: subcategory.newBadge ?? undefined,
      })) || []
    );
  }, [subcategoriesWithProductCount, filterState.selectedCategoryUids]);

  const handleChange = useCallback(
    (uid: string) => {
      toggleCategory(uid);
    },
    [toggleCategory]
  );

  return {
    handleChange,
    updatedSubcategories,
    discontinuedProductName,
  };
};

export default useHandleFilters;
